import 'reflect-metadata';
import { Expose, plainToInstance, instanceToPlain } from 'class-transformer';

export class Language {
  id: number;
  name: string;

  @Expose({ name: 'native_name' })
  nativeName?: string;

  code: string;

  constructor(id: number, name: string, code: string, nativeName?: string) {
    this.id = id;
    this.name = name;
    this.code = code;
    this.nativeName = nativeName;
  }

  static fromJson(json: Record<string, any>): Language {
    return plainToInstance(Language, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
